import { combineReducers } from "@reduxjs/toolkit";
import { customerAuthAPi } from "./actions/Customer/authCustomer";
import { authReducer } from "./reducers/authReducer";
import { adminReducer } from "./reducers/Admin/adminReducer";
import { adminAuthAPi } from "./actions/Admin/authAdmin";
import { customerProfileAPi } from "./actions/Customer/profileCustomer";
import { adminServiceAPi } from "./actions/Admin/ServiceAdmin";
import { adminPetsAPi } from "./actions/Admin/PetsAdmin";
import { adminDashboardAPi } from "./actions/Admin/dashboardAdmin";
import { serviceCustomerAPi } from "./actions/Customer/serviceCustomer";
import { adminProductAPi } from "./actions/Admin/ProductAdmin";
import { footerManagementAdminAPi } from "./actions/Admin/footerManagementAdmin";
import { customerFooterAPi } from "./actions/Customer/FooterCustomer";
import { customerCartAPi } from "./actions/Customer/cartCustomer";
import { adminOrderAPi } from "./actions/Admin/orderAdmin";
import { adminAbandonedCartAPi } from "./actions/Admin/abandonedCartAdmin";
import { analyticsApi } from "./actions/Admin/AnalyticsApi";
import { customerAnalyticsApi } from "./actions/Customer/analyticsCustomer";

const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  [customerAuthAPi.reducerPath]: customerAuthAPi.reducer,

  [adminAuthAPi.reducerPath]: adminAuthAPi.reducer,
  [adminServiceAPi.reducerPath]: adminServiceAPi.reducer,
  [customerProfileAPi.reducerPath]: customerProfileAPi.reducer,
  [adminPetsAPi.reducerPath]: adminPetsAPi.reducer,
  [adminDashboardAPi.reducerPath]: adminDashboardAPi.reducer,
  [serviceCustomerAPi.reducerPath]: serviceCustomerAPi.reducer,
  [adminProductAPi.reducerPath]: adminProductAPi.reducer,
  [footerManagementAdminAPi.reducerPath]: footerManagementAdminAPi.reducer,
  [customerFooterAPi.reducerPath]: customerFooterAPi.reducer,
  [customerCartAPi.reducerPath]: customerCartAPi.reducer,
  [adminOrderAPi.reducerPath]: adminOrderAPi.reducer,
  [adminAbandonedCartAPi.reducerPath]: adminAbandonedCartAPi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [customerAnalyticsApi.reducerPath]: customerAnalyticsApi.reducer,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
